import {useUrlSegmentGroupData} from 'modules/router/hooks/useUrlSegmentGroupData';
import {COMBO_FILTER_URL_ROUTE, ROUTER_QUERY_TAG_OR_COLLECTION_KEY} from 'plugins/modules/filter/constants';
import {ITagData} from 'plugins/modules/filter/types';

export const useActiveComboFilter = (): ITagData | null => {
    return useUrlSegmentGroupData<ITagData>(COMBO_FILTER_URL_ROUTE, ROUTER_QUERY_TAG_OR_COLLECTION_KEY);
};
